import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { shareReplay, switchMap } from 'rxjs/operators';
import { CustomEmoji, CustomSignupTemplate, SignupGroupTemplate } from 'src/app/models/bot/guild';
import { BotResourceService } from 'src/app/services/bot-resource.service';

@Component({
  selector: 'app-signupGroup-card',
  templateUrl: './signupGroup-card.component.html',
  styleUrls: [
    '../shared/styles/guild-dashboard-shared.css',
    './signupGroup-card.component.css'
  ],
})
export class SignupGroupCardComponent implements OnInit {
  guildId: string;
  signupGroupId: string;
  @Input() customEmojis$: Observable<CustomEmoji[]>;
  @Input() signupGroupInfo$: Observable<SignupGroupTemplate>;
  combinedData$: Observable<{
    signupGroupInfo: SignupGroupTemplate;
    customEmojis: CustomEmoji[];
  }>;

  constructor(
    private route: ActivatedRoute,
    private botService: BotResourceService
  ) {}

  ngOnInit() {
    this.guildId = this.route.parent.snapshot.paramMap.get('id');
    this.customEmojis$ = this.botService
      .getGuildEmoji(this.guildId)
      .pipe(shareReplay(1));
    this.customEmojis$.subscribe((customEmojis) => {
      // iterate over custom emojis and make the string `name` a list with a single entry
      customEmojis.forEach((customEmoji) => {
        customEmoji.shortNames = [customEmoji.name, customEmoji.full_id];
      });
    });
    // Angular reuses the component when navigating between routes within the same component.
    // This means that the component is not destroyed and recreated, so ngOnInit is not called again.
    // We therefore need to subscribe to the paramMap observable and update the component when the route changes.
    this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          this.signupGroupId = params.get('signupGroupId');
          if (this.signupGroupId === null) {
            // Use default values when the signupGroupId is 'new'
            this.signupGroupInfo$ = of({
              // Default values for a new signup template
              identifier: null,
              signupGroupTitle: '',
              signupTemplate: '',
              userSelections: {},
            });
          } else {
            // Fetch data from the API
            this.signupGroupInfo$ = this.botService
              .getSignupGroup(this.guildId, this.signupGroupId)
              .pipe(shareReplay(1));
          }
          this.combinedData$ = forkJoin({
            signupGroupInfo: this.signupGroupInfo$,
            customEmojis: this.customEmojis$,
          });
          return of(null);
        })
      )
      .subscribe(
        //print the template
        () => {}
      );
  }
}
